import NavigationItemsSlider from "./NavigationItemsSlider.jsx";
import NavigationSecondLevel from "./NavigationSecondLevel.jsx";
import {useEffect, useState} from "react";
import Landmark from '@core/scripts/components/landmark-adapter';
import {useMobileNavigationContext} from "../../context/mobile-navigation-context.jsx";
import {getMobileNavigationItems} from "../../../helper/sub-navigation-helper.js";

export default function NavigationFirstLayer({
                                                 activeFirstLevelId,
                                                 setActiveFirstLevelId,
                                                 selectSecondLevelItem,
                                                 visible
                                             }) {
    const {navigationItems, texts} = useMobileNavigationContext()

    const [nextActiveFirstLevelId, setNextActiveFirstLevelId] = useState(null);

    useEffect(() => {
        if (visible) {
            const item = navigationItems.find(item => item.id === activeFirstLevelId);
            const lmValue = {view: `pictureNaviLayer\\${item.id}`};
            Landmark.sendActionLandmark(lmValue);
        }
    }, [visible]);

    const activeIndex = navigationItems.findIndex(item => item.id === activeFirstLevelId);
    const nextActiveIndex = nextActiveFirstLevelId ? navigationItems.findIndex(item => item.id === nextActiveFirstLevelId) : null;

    const previousSlide = nextActiveIndex != null && nextActiveIndex < activeIndex;
    const nextSlide = nextActiveIndex != null && nextActiveIndex > activeIndex;

    const transition = () => {
        if (previousSlide) {
            return 'swipe-left';
        }
        if (nextSlide) {
            return 'swipe-right';
        }
        return "";
    }

    const nextMobileNavigationItems = nextActiveFirstLevelId ? getMobileNavigationItems(navigationItems.find(item => item.id === nextActiveFirstLevelId)) : [];
    const activeMobileNavigationItems = getMobileNavigationItems(navigationItems.find(item => item.id === activeFirstLevelId))

    return (
        <>
            <NavigationItemsSlider
                items={navigationItems}
                activeId={activeFirstLevelId}
                setActiveId={setActiveFirstLevelId}
                setNextActiveId={setNextActiveFirstLevelId}
                texts={texts}
            />
            <div className={`navigation__second-level-wrapper`}>
                {previousSlide && (
                    <div className={`navigation__sub-navigation-slide swipe-left`}>
                        <NavigationSecondLevel secondLevelItems={nextMobileNavigationItems} />
                    </div>
                )}
                <div className={`navigation__sub-navigation-slide ${transition()}`}>
                    <NavigationSecondLevel
                        secondLevelItems={activeMobileNavigationItems}
                        selectSecondLevelItem={selectSecondLevelItem}
                        activeFirstLevelId={activeFirstLevelId}
                    />
                </div>
                {nextSlide && (
                    <div className={`navigation__sub-navigation-slide swipe-right`}>
                        <NavigationSecondLevel secondLevelItems={nextMobileNavigationItems} />
                    </div>
                )}
            </div>
        </>
    );
}